//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
import { memo } from 'react';
import { BzModal, BzModalBody, BzModalHeader } from '../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../redux/actions/modals';
import { updateInAppIFrame } from '../redux/actions/appInfo';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router';

const IFrame = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modals = useSelector(state => state.modals.modals);
    const objInAppIFrameData = useSelector(state => state.appInfo.inAppIFrameData);

    const onCloseIFrameModal = (e) => {
        // {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
        dispatch(handleModal([{ "IN_APP_IFRAME": false }], true)); // Persisted data should be cleared when parent modal is closed 
        // {/* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }
        dispatch(updateInAppIFrame({ url: '', title: 'InApp' }));

            {/* BT-128486 Vinit Raut 19/02/2024 -- Error Boundary - End */}
        const pathWithoutQuery = location.pathname;  // Deepti B.[11/10/2024] get the path without query params
        navigate(pathWithoutQuery)  // DeeptiB. [11/10/2024] Replace the current URL with the one without query params
    };

    return (
        <BzModal centered size='fullscreen' show={modals['IN_APP_IFRAME']} onHide={onCloseIFrameModal} backdrop={false}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0 align-items-center'>
                        <Col md={11} className='d-flex align-items-center'>
                            <div className='font-medium font-size4 color-text'>{objInAppIFrameData?.title}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onCloseIFrameModal}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <object id='iFrameObject' data={objInAppIFrameData?.url} height='100%' width='100%' aria-label={objInAppIFrameData?.title} />
            </BzModalBody>
        </BzModal>
    );
};

export default memo(IFrame);
//Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End
